import LoadingIcon from "components/basic/LoadingIcon/LoadingIcon";
import { System_Info } from "model/Datatypes";
import React from "react";

interface Props {
  systemInfo: System_Info;
}

const SystemInfo = ({ systemInfo }: Props) => {
  const { systemInformation } = systemInfo;

  return (
    <div
      className={`rounded relative  w-full overflow-hidden bg-white text-gray-600 flex flex-col text-xs font-base 2xl:text-3xl border border-gray-200 shadow-xxl
        h-full`}
    >
      <div className="text-gray-600 mt-6 2xl:mt-12 ml-7 mb-2 font-medium">
        System specification
      </div>

      {Object.entries(systemInformation).map((si) => {
        return (
          <div
            key={si[0]}
            className="flex-1 flex items-center justify-between border-b border-gray-200 hover:bg-gray-100 px-3 2xl:px-5"
          >
            <div className="px-4 text-gray-500">{si[0]}</div>
            <div className="font-medium px-4">{si[1]}</div>
          </div>
        );
      })}

      {!systemInformation && (
        <div
          className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white opacity-75 text-gray-700"
          style={{ fontSize: "4rem" }}
        >
          <LoadingIcon />
        </div>
      )}
    </div>
  );
};
export default SystemInfo;
